<template>
  <div class="container">
    <back-box style="width: 100%" />
    <div class="top">
      <h1>版权存证</h1>
    </div>
    <div class="formBox">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px">
        <el-form-item label="作品名称" prop="worksName">
          <el-input :disabled="acceptStr.isType" placeholder="请输入作品名称" v-model="ruleForm.worksName" clearable></el-input>
        </el-form-item>
        <el-form-item label="作品所有者" prop="ownerUsn">
          <el-select v-model="ruleForm.ownerUsn" filterable remote reserve-keyword placeholder="请输入作品所有者" :disabled="acceptStr.isType" :remote-method="remoteMethod" :loading="loadings">
            <el-option v-for="item,index in ownerData" :key="index" :label="item.truename||item.nickname||item.username" :value="item.usn">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="作品类型" prop="worksType">
          <el-select v-model="ruleForm.worksType" placeholder="请选择作品类型" clearable :disabled="acceptStr.isType">
            <el-option v-for="item,index in worksTypeData" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="作品文件" prop="fileList">
          <el-upload class="elWorksFile" action="string" :disabled="acceptStr.isType" :http-request="handleRequest" :on-remove="handleRemove" :file-list="ruleForm.fileList">
            <el-button size="small" type="primary" :disabled="acceptStr.isType">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-if="!acceptStr.isType" @click="handleSubmit('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    var checkFileList = (rule, value, callback) => {
      if (value.length>0) {
        callback();
      } else {
        callback(new Error('请选择作品文件'));
      }

    };
    return {
      ruleForm: {
        id: '',
        applicantUsn: '',//申请人usn
        orgUsn: 'bb856cc72818c5226d4226728a16fcd19911de041446e4759c58017cb146ddcc',//机构usn
        worksName: '',//作品名称
        ownerUsn: '',//作品所有者
        worksType: '',//作品类型
        worksFile: null,//作品文件
        fileList: [],//文件列表-不提交
      },
      rules: {
        worksName: [
          { required: true, message: '请输入作品名称', trigger: 'blur' },
        ],
        ownerUsn: [
          { required: true, message: '请选择作品所有者', trigger: 'change' },
        ],
        worksType: [
          { required: true, message: '请选择作品类型', trigger: 'change' },
        ],
        fileList: [
          { required: true, validator: checkFileList, message: '请选择作品文件', trigger: 'change' },
        ],
      },
      acceptStr: {  
        isType: false
      },
      loadings: false,
      ownerData: [],
      worksTypeData: [
        {
          label: '文字',
          value: '1'
        },
        {
          label: '口述',
          value: '2'
        },
        {
          label: '音乐',
          value: '3'
        },
        {
          label: '戏剧',
          value: '4'
        },
        {
          label: '曲艺',
          value: '5'
        },
        {
          label: '舞蹈',
          value: '6'
        },
        {
          label: '杂技',
          value: '7'
        },
        {
          label: '美术',
          value: '8'
        },
        {
          label: '建筑',
          value: '9'
        },
        {
          label: '摄影',
          value: '10'
        },
        {
          label: '电影',
          value: '11'
        },
        {
          label: '类似摄制电影方法创作',
          value: '12'
        },
        {
          label: '工程设计图、产品设计图',
          value: '13'
        },
        {
          label: '地图、示意图',
          value: '15'
        },
        {
          label: '模型',
          value: '17'
        },
        {
          label: '录音制品',
          value: '19'
        },
        {
          label: '录像制品',
          value: '20'
        },
        {
          label: '其他作品',
          value: '181'
        },

      ],
      isClear: false,
      worksPathType: '',
      worksPath: '',

    }
  },
  created() {
    this.ruleForm.applicantUsn = this.$store.state.userData.usn;

    if (this.$route.query.id) {
      this.ruleForm.id = this.$route.query.id;
      this.ruleForm.worksName = this.$route.query.worksName;
      this.ruleForm.worksType = this.$route.query.worksType;
      this.ruleForm.fileList.push({ name: this.$route.query.worksFile });
      this.ruleForm.ownerUsn = this.$route.query.ownerUsn;
      this.remoteMethod(this.$route.query.ownerName);
      this.$route.query.type==2?this.acceptStr.isType = true:this.acceptStr.isType =false
    } else {
      if (this.$store.state.userData && this.$store.state.userData.truename) {
        this.ruleForm.ownerUsn = this.$store.state.userData.usn;
        this.remoteMethod(this.$store.state.userData.truename, 1)

      }
    }
  },
  methods: {
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.loading();
          let fd = new FormData();
          fd.append("applicantUsn", this.ruleForm.applicantUsn);
          fd.append("orgUsn", this.ruleForm.orgUsn);
          fd.append("worksName", this.ruleForm.worksName);
          fd.append("ownerUsn", this.ruleForm.ownerUsn);
          fd.append("worksType", this.ruleForm.worksType);
          let ip
          if (this.ruleForm.worksFile) {
            fd.append("worksFile", this.ruleForm.worksFile);
          }

          if (this.ruleForm.id) {
            fd.append("id", this.ruleForm.id);
            ip = '/storage/evidence/update';
          } else {
            ip = '/storage/evidence/info/collect';
          }

          this.$axios.post(this.$store.state.moreCr_url + ip,
            fd
          ).then(res => {
            loading.close();
            if (res.data.code == 200) {
              this.$message({
                message: '提交成功',
                type: 'success'
              });
              this.$router.push({path: "/newCopyright/evidenceList"});
            } else {
              this.$message.error(res.data.message);
            }
          })
          // 
        }
      })
    },
    handleRemove() {
      this.ruleForm.worksFile = null;
      this.ruleForm.fileList = [];
    },
    handleRequest(val) {
      this.ruleForm.fileList = [];
      this.ruleForm.worksFile = val.file;
      this.ruleForm.fileList = [{name:val.file.name}];
      this.$refs['ruleForm'].clearValidate('fileList');


    },
    remoteMethod(query) {
      if (query !== '') {
        this.loadings = true;
        this.$axiosPost(this.$store.state.login_url + "/userInfo/searchUserByKeyword", {
          keyword: query
        }).then(res => {
          this.loadings = false;
          if (res.code == 200) {
            this.ownerData = res.data.filter(item => {
              return item.truename.toLowerCase().indexOf(query.toLowerCase()) > -1;
            })
          }
        })

      } else {
        this.ownerData = [];
      }
    },

  }
}
</script>
<style scoped lang="scss">
.top {
  height: 22px;
  padding: 38px 33px;
  h1 {
    float: left;
    color: #333;
    line-height: 22px;
    font-size: 22px;
    margin: 0;
  }
}
.elWorksFile {
  width: 50%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #1C77FF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
::v-deep .but-el .el-button--warning{
  // border-color: #1C77FF;
  // color: #1C77FF;
  background-color: #1C77FF;
    border-color: #1C77FF;
}
::v-deep.el-upload--picture-card:hover,
.el-upload:focus {
  border-color: #1C77FF;
  color: #1C77FF;
}
::v-deep.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
}
.el-input {
  width: 218px;
}
</style>
